import { Component, HostListener } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faMars, faVenus, faCheck, faClose, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { ApiServicesService } from '../services/api-services.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { UserDetailsService } from '../services/user-details.service';
import { SnackbarService } from '../services/snackbar.service';
import { response } from 'express';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    MatTabsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
})
export class SettingsComponent {

  selectedTabIndex = 0;
  formGroup: FormGroup;
  formGroupEmail: FormGroup;
  passwordMismatch: boolean = false;
  userEmail: any;
  res_error: any;
  userName_API: any;

  blocked: any[] = [];
  formGroupPrivacy: any;
  loader: boolean = false;
  page: any = 1;
  limit: any = 10;
  totalPages: any = 1;
  activePage = '';
  privacyDropdown: any = [];
  privacyUpdate = false;
  isloading = false;

  constructor(private fb: FormBuilder, private apiservices: ApiServicesService, private userdetails: UserDetailsService, private snackbarService: SnackbarService, private route: ActivatedRoute) {
    this.formGroup = this.fb.group({
      newPass: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,30}$/)
        ]
      ],
      confirmPass: ['', Validators.required],
    });


    this.formGroupEmail = this.fb.group({
      userName: [{ value: '', disabled: true }, Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });

    this.formGroupPrivacy = this.fb.group({
      pictures_privacy: ['', Validators.required],
      friends_privacy: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.userdetails.userdetails$.subscribe((userData) => {
      this.userEmail = userData?.user?.email;
      this.userName_API = userData?.user?.username;
    });
    this.formGroupEmail.patchValue({
      userName: this.userName_API,
      email: this.userEmail
    })


    this.route.queryParamMap.subscribe((query: any) => {
      if (query.params['tab'] == 'block') {
        this.blockUsers(1, this.limit);
        this.activePage = 'Blocked Members';
        this.selectedTabIndex = 1;
      }
    });


  }

  unblock(userId: any) {
    this.apiservices.unblock(userId).subscribe({
      next: (response: any) => {
        if(response.status==200){
        this.blockUsers(this.page, this.limit);
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: response.message,
            className: 'success',
          }
        );
      }else{
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: response.message,
            className: 'failed',
          }
        );

      }
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  onTabChange(event: MatTabChangeEvent) {
    if (event.tab.textLabel === 'Blocked Members') {
      this.blockUsers(1, this.limit);
      this.activePage = 'Blocked Members';
    } else if (event.tab.textLabel === 'Privacy') {
      if (this.privacyDropdown.length == 0) {
        this.apiservices.getPrivacySettings().subscribe({
          next: (response: any) => {
            this.privacyDropdown = response.data;
          }
        })
      }

      this.apiservices.getPrivacySettingsDatas().subscribe({
        next: (response: any) => {
          this.formGroupPrivacy.patchValue({
            pictures_privacy: response.viewPictures._id,
            friends_privacy: response.viewFriends._id
          })
        },
        error: (err) =>{
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );

        }
      })

    } else {
      this.activePage = '';
    }
  }

  blockUsers(page: any, limit: any) {
    this.loader = true;
    this.apiservices.blockUsers(page, limit).subscribe({
      next: (response: any) => {
        if (page == 1) {
          this.blocked = response.data.blockedUsers || [];
        } else {
          this.blocked = [...this.blocked, ...(response.data.blockedUsers || [])];
        }
        this.totalPages = response.data.pagination?.totalPages || 1;
        this.page = parseInt(response.data.pagination?.currentPage) || 1;
        this.loader = false;
      },
      error: (err) => {
        this.loader = false;
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    });
  }

  onSubmit() {
    this.isloading = true;
    this.res_error = ''
    const password = this.formGroup.get('newPass')?.value;
    const confirmPass = this.formGroup.get('confirmPass')?.value;
    // console.log(password, 'pass', password)
    if (confirmPass !== '' && password !== confirmPass) {
      this.passwordMismatch = true;
      this.isloading = false;
    } else if (confirmPass !== '') {
      this.passwordMismatch = false;
      this.apiservices.reserPass(this.userEmail, confirmPass).subscribe({
        next: (response: any) => {
          this.isloading = false;
          this.snackbarService.openCustomSnackbar(
            {
              icon: true,
              message: 'Password Updated successfully',
              className: 'success',
            }
          );

        },
        error: (err) => {
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    } else {

    }
  }

  onPrivacySubmit() {
    const viewPictures = this.formGroupPrivacy.get('pictures_privacy')?.value;
    const viewFriends = this.formGroupPrivacy.get('friends_privacy')?.value;
    if (this.formGroupPrivacy.valid) {
      this.privacyUpdate = true;
      this.apiservices.update_privacy(viewPictures, viewFriends).subscribe({
        next: (response: any) => {
          this.privacyUpdate = false;
          this.snackbarService.openCustomSnackbar(

            {
              icon: true,
              message: 'Privacy Updated successfully',
              className: 'success',
            }
          );

        },
        error: (err) => {
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
          
        }
      });
    } else {
      this.formGroup.markAllAsTouched();
    }

  }





  // Handle email form submission
  onSubmitEmail() {
    if (this.formGroupEmail.valid) {
      const email = this.formGroupEmail.get('email')?.value;
      this.apiservices.updateEmail(email).subscribe({
        next: (response: any) => {
          if (response.status == 200) {
            const encryptedData = this.apiservices.encryptData(response);
            localStorage.setItem('encryptedUserData', encryptedData);
            this.privacyUpdate = false;
            this.snackbarService.openCustomSnackbar(
              {
                icon: true,
                message: 'Email Updated successfully',
                className: 'success',
              }
            );
          } else {
            this.snackbarService.openCustomSnackbar(
              {
                icon: false,
                message: response.message,
                className: 'failed',
              }
            );

          }

        },
        error: (err) => {
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: err.error.message,
              className: 'failed',
            }
          );
        }
      });
    } else {
    }
  }

  @HostListener('window:scroll', ["$event"])
  onScroll(): void {
    if (
      this.page < this.totalPages &&
      !this.loader
    ) {
      this.page++;
      if (this.activePage == 'Blocked Members') {
        this.blockUsers(this.page, this.limit);
      }
    }
  }
}
